@if (checkInsSummary()) {
  <div class="check-ins-summary-survey-list">
    @for (c of checkInsSummaryFormatted(); track c.name) {
      <div class="check-ins-summary-survey-list__item"
           (click)="checkInClicked(c.name, c.statusIcon)"
           [ngClass]="{ 'check-ins-summary-survey-list__item-clickable': isItemClickable(c.statusIcon) }">
        <lib-icon [iconName]="c.statusIcon"></lib-icon>
        <span>{{ c.label }}</span>

        @if (outsideSelectedSurvey() && outsideSelectedSurvey() === c.name) {
          <div class="check-ins-summary-survey-list__item__selector">
            <lib-icon iconName="checkInsSelectorIcon"></lib-icon>
          </div>
        }
      </div>
    }
  </div>
}
